'use client'

/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import {FC} from 'react'
import Link, {LinkProps} from 'next/link'
import {useSearchParams, usePathname, useParams} from 'next/navigation'
import {getPathAlias, sessionStartQPKey} from '@app/analytics/helper'
import {interalNavigationQuery} from '@app/components/custom-links/game-link'
import {useIsCanonicalHost} from '../../session-attributes/use-is-canonical-host'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'
import {ReffererLayoutQueryName} from '@app/analytics/analytics-provider/constants'

type LinkTagProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  LinkProps & {
    reffererLayout?: ReffererLayout
  }

const CometLink: FC<LinkTagProps> = ({children, prefetch = false, reffererLayout, ...restProps}) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const params = useParams()
  const {isExtendedCanonical} = useIsCanonicalHost()
  const query = searchParams ? Object.fromEntries(searchParams.entries()) : {}
  const lang = params?.lang || 'en'
  let pathToPrefix = `/${lang}`

  const queryToAppend = {
    [sessionStartQPKey]: getPathAlias(pathname || ''),
    ...query,
    ...interalNavigationQuery,
    ...(reffererLayout ? {[ReffererLayoutQueryName]: reffererLayout} : {}),
  }

  return (
    <Link
      {...restProps}
      href={{
        pathname: `${pathToPrefix}${restProps.href}`,
        query: isExtendedCanonical ? {} : queryToAppend,
      }}
      scroll={true}
      prefetch={prefetch}
    >
      {children}
    </Link>
  )
}

export default CometLink
